<div class="info-block">
  <h3 class="info-title">
    {{ 'account_customer_info.contacts' | translate }}
  </h3>

  <div class="info-content">
    <customer-info [source]="'account'" />
  </div>
</div>

<div class="info-block">
  <h3 class="info-title">
    {{ 'global.password' | translate }}
  </h3>

  <tc-button
    class="info-edit-btn"
    (click)="changePassword()"
    buttonSize="small"
    [isTransparent]="true"
  >
    {{ 'global.change_password' | translate }}
  </tc-button>
</div>
